import { apiRequest } from "./client";

const base = (guildId) => `/api/v1/guilds/${guildId}/autoroles`;

export const getAutoroles = (guildId) => apiRequest(base(guildId));
export const addAutorole = (guildId, payload) =>
  apiRequest(base(guildId), { method: "POST", body: payload });
export const editAutorole = (guildId, roleId, payload) =>
  apiRequest(`${base(guildId)}/${roleId}`, { method: "PATCH", body: payload });
export const deleteAutorole = (guildId, roleId) =>
  apiRequest(`${base(guildId)}/${roleId}`, { method: "DELETE" });
